import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { List } from '../../../../../components/atoms';
import { ListItem as ListItemType } from '../../../../../components/atoms/List';
import {
  ChevronRight as ChevronRightIcon,
  Message as MessageIcon,
  Profile as ProfileIcon,
} from '../../../../../components/icons';
import { ProfileActionsType } from '../../../../../types/menu';
import * as Api from '../../../../../weborder/Api';

type Props = {
  actions: ProfileActionsType;
  configData: Api.AppConfig;
  contactFormType: Api.ContactFormType;
  translate: any;
};

const useStyles = makeStyles((theme: Theme) => ({
  notLoggedIn: {
    marginBottom: theme.spacing(6.5),

    '& .loginList': {
      padding: 0,

      '& .MuiListItem-root': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
  },

  [theme.breakpoints.up('lg')]: {
    notLoggedIn: {
      margin: 0,
      padding: theme.spacing(1.5, 0),

      '& .loginList': {
        '& .MuiListItem-root:first-child, & .MuiListItem-root:only-child': {
          borderTop: '1px solid transparent',

          '&:hover': {
            borderTop: `1px solid ${theme.palette.primary.main}`,
          },
        },
        '& .MuiListItem-root:last-child, & .MuiListItem-root:only-child': {
          borderBottom: '1px solid transparent',

          '&:hover': {
            borderBottom: `1px solid ${theme.palette.primary.main}`,
          },
        },
      },
    },
  },
}));

export function NotLoggedInPartial(props: Props): JSX.Element {
  const { actions, contactFormType, translate } = props;

  const classes = useStyles();

  const notLoggedInItems = {
    login: {
      action: actions.onLogin,
      dataFd: 'profile-login',
      label: translate('Log_in'),
      leftIcon: <ProfileIcon />,
      rightIcon: <ChevronRightIcon />,
    },
    contactUs: {
      action: actions.onContactUs,
      dataFd: 'profile-contact-us',
      label: translate('Contact_us'),
      leftIcon: <MessageIcon />,
      rightIcon: null,
    },
  };

  const hasContactUs = contactFormType === Api.ContactFormType.Intercom;
  if (!hasContactUs) {
    delete notLoggedInItems.contactUs;
  }

  const items: ListItemType[] = Object.values(notLoggedInItems).map((item) => {
    return {
      leftIcon: item.leftIcon,
      onClick: item.action,
      primaryContent: item.label,
      rightIcon: item.rightIcon,
      testId: item.dataFd,
    };
  });

  return (
    <div className={classes.notLoggedIn}>
      <List className="loginList" items={items} />
    </div>
  );
}
